exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-10[data-v-3c5abc1d]{margin-bottom:10rem}", ""]);

// exports
